import { Grid, TextField, Typography, Card, CardContent, Box } from "@mui/material";
import { ChangeEvent, useState } from "react";

import { useParams } from "react-router-dom";
import numericValidator from "services/numericValidator";
import { AlertsProps } from "components/Alerts/data/Alerts.type";
import { DiscountFactorModel } from "./data/DiscountFactorModel";
import { _updatediscountfactor } from "middlewares/LocationApi/location";
import { useAppState } from "context/appState.context";
import LoadingAndSnackbar from "../LoadingAndSnackbar";

/**
 * Component for managing user role configuration for an location.
 * @component
 */
const DiscountFactor = () => {
  const { LocationId } = useParams();
  const { discountFactor, setDiscountFactor } = useAppState();
  const [discountFactorModel, setDiscountFactorModel] =
    useState<DiscountFactorModel>({
      locationID: Number(LocationId),
      discountFactor: discountFactor,
    });
  const [success, setSuccess] = useState<AlertsProps>({
    show: false,
    severity: "info",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setDiscountFactorModel((prevState) => ({
      ...prevState,
      [name]: numericValidator.allowNumericValue(value),
    }));
  };

  const handleCloseSnackBar = (state: AlertsProps) => {
    setSuccess(state);
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      const res = await _updatediscountfactor(discountFactorModel);
      if (res) {
        setLoading(false);
        setDiscountFactor(discountFactorModel.discountFactor ?? 0);
        const message = "Data Saved Successfully !";
        handleCloseSnackBar({
          show: true,
          severity: "success",
          message: message,
        });
      }
    } catch (err) {
      console.error("Error:", err);
      handleCloseSnackBar({
        show: true,
        severity: "error",
        message: "Failed to save data. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        transform: 'scale(0.75)',
        transformOrigin: 'top left',
        width: '133.33%', // 1 / 0.75 for compensation
        minHeight: '100vh',
      }}
    >
      <Card sx={{ mb: 3, p: 2 }}>
        <CardContent>
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", mb: 2 }}
            data-testid="userRoleConfigTitle"
          >
            Discount Factor Configuration
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={6} sm={4} md={3}>
              <Typography
                variant="body2"
                sx={{ fontSize: 14, fontWeight: "light", mb: 1 }}
                data-testid="adminsLabel"
              >
                Discount Factor
              </Typography>
              <TextField
                required
                name="discountFactor"
                size="small"
                fullWidth
                inputProps={{
                  "data-testid": "discountFactor",
                  inputMode: "numeric",
                }}
                value={discountFactorModel.discountFactor}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <LoadingAndSnackbar
        loading={loading}
        success={success}
        handleCloseSnackBar={handleCloseSnackBar}
        handleSave={handleSave}
      />
    </Box>
  );
};

export default DiscountFactor;
